// extracted by mini-css-extract-plugin
module.exports = {"submitting":"autoSave_submitting__IHN3t","animate":"autoSave_animate__2sMcR"};